export const FILTERBYSEX = {
  ALL: 'all',
  M: 'm',
  F: 'f',
};

export const SORTBY = {
  NAME: 'name',
  SEX: 'sex',
  BORN: 'born',
};
